import { normalizeText } from './textNormalizationHelpers';

const MAINTENANCE_TYPE = Object.freeze({
    INCOMPANY: "incompany",
    OFICINA: "oficina",
    UNKNOWN: "unknown",
});

const MAINTENANCE_LOCALIZATION_MAP = Object.freeze({
    empresa: MAINTENANCE_TYPE.INCOMPANY,
    incompany: MAINTENANCE_TYPE.INCOMPANY,
    "in company": MAINTENANCE_TYPE.INCOMPANY,
    oficina: MAINTENANCE_TYPE.OFICINA,
    service: MAINTENANCE_TYPE.OFICINA,
});

const maintenanceTypeStyles = Object.freeze({
    [MAINTENANCE_TYPE.INCOMPANY]: {
        chipBackground: "#E7F1FF",
        chipColor: "#0D6EFD",
        borderColor: "#0D6EFD",
        cardBackground: "#F7FBFF",
        indicatorColor: "#0D6EFD",
    },
    [MAINTENANCE_TYPE.OFICINA]: {
        chipBackground: "#E8F6EE",
        chipColor: "#198754",
        borderColor: "#198754",
        cardBackground: "#F8FCFA",
        indicatorColor: "#198754",
    },
    [MAINTENANCE_TYPE.UNKNOWN]: {
        chipBackground: "#F1F3F5",
        chipColor: "#6C757D",
        borderColor: "#CED4DA",
        cardBackground: "#FFFFFF",
        indicatorColor: "#6C757D",
    },
});

const MAINTENANCE_API_TYPE_LABELS = Object.freeze({
    [MAINTENANCE_TYPE.INCOMPANY]: "InCompany",
    [MAINTENANCE_TYPE.OFICINA]: "Oficina",
    [MAINTENANCE_TYPE.UNKNOWN]: "",
});

const mapRawTypeToMaintenanceType = (rawValue) => {
    const normalized = normalizeText(rawValue);
    if (!normalized) return MAINTENANCE_TYPE.UNKNOWN;

    if (MAINTENANCE_LOCALIZATION_MAP[normalized]) {
        return MAINTENANCE_LOCALIZATION_MAP[normalized];
    }

    if (
        normalized.includes("incompany") ||
        normalized.includes("in company") ||
        normalized.includes("empresa")
    ) {
        return MAINTENANCE_TYPE.INCOMPANY;
    }

    if (normalized.includes("oficina") || normalized.includes("service")) {
        return MAINTENANCE_TYPE.OFICINA;
    }

    return MAINTENANCE_TYPE.UNKNOWN;
};

const inferMaintenanceTypeFromAddress = (address) => {
    const normalizedAddress = normalizeText(address);
    if (!normalizedAddress) return MAINTENANCE_TYPE.UNKNOWN;

    if (normalizedAddress.includes("oficina") || normalizedAddress.includes("service")) {
        return MAINTENANCE_TYPE.OFICINA;
    }

    if (
        normalizedAddress.includes("incompany") ||
        normalizedAddress.includes("in company") ||
        normalizedAddress.includes("empresa")
    ) {
        return MAINTENANCE_TYPE.INCOMPANY;
    }

    return MAINTENANCE_TYPE.INCOMPANY;
};

const normalizeMaintenanceType = (data = {}) => {
    const directType = mapRawTypeToMaintenanceType(data.tipoManutencao);
    if (directType !== MAINTENANCE_TYPE.UNKNOWN) return directType;

    const localizationType = mapRawTypeToMaintenanceType(data.maintenanceLocalization);
    if (localizationType !== MAINTENANCE_TYPE.UNKNOWN) return localizationType;

    return inferMaintenanceTypeFromAddress(data.endereco);
};

const getMaintenanceTypeLabel = (type) => {
    if (type === MAINTENANCE_TYPE.INCOMPANY) return "InCompany (Na minha empresa)";
    if (type === MAINTENANCE_TYPE.OFICINA) return "Oficina (Service)";
    return "Não informado";
};

const getMaintenanceStyle = (type) =>
    maintenanceTypeStyles[type] || maintenanceTypeStyles[MAINTENANCE_TYPE.UNKNOWN];

const getMaintenanceExecutionLabel = (data = {}) => {
    const normalizedType = normalizeMaintenanceType(data);
    return getMaintenanceTypeLabel(normalizedType);
};

const getMaintenanceApiTypeLabel = (type) =>
    MAINTENANCE_API_TYPE_LABELS[type] || MAINTENANCE_API_TYPE_LABELS[MAINTENANCE_TYPE.UNKNOWN];

const getDefaultWorkshopAddress = () =>
    MAINTENANCE_API_TYPE_LABELS[MAINTENANCE_TYPE.OFICINA];

export {
    MAINTENANCE_TYPE,
    maintenanceTypeStyles,
    normalizeText,
    normalizeMaintenanceType,
    getMaintenanceTypeLabel,
    getMaintenanceStyle,
    getMaintenanceExecutionLabel,
    getMaintenanceApiTypeLabel,
    getDefaultWorkshopAddress,
};
